import { Api } from "@lcms/api-definition";
import { saveEndpoint } from "./save-endpoint";
import { getEndpoint } from "./get-endpoint";
import { removeEndpoint } from "./remove-endpoint";

export const configurationRouter = Api.getRouter()
    .use(saveEndpoint.inNamespace('configuration').toDefinition())
    .use(getEndpoint.inNamespace('configuration').toDefinition())
    .use(removeEndpoint.inNamespace('configuration').toDefinition())